import { USER_PLANS } from 'config/appConfig';
import { lazy } from 'react';

export default [
  {
    path: '/home',
    label: 'Dashboard',
    icon: lazy(() => import('@material-ui/icons/DashboardTwoTone')),
    license: USER_PLANS.udt,
  },
  {
    path: '/watchlist',
    label: 'Grid',
    icon: lazy(() => import('@material-ui/icons/DescriptionOutlined')),
    license: USER_PLANS.udt,
  },
  // {
  //   path: '/social-screener',
  //   label: 'Social Screener',
  //   icon: lazy(() => import('@material-ui/icons/AllOut')),
  //   license: USER_PLANS.udt,
  // },
  {
    path: '/topic',
    label: 'ThemeX',
    icon: lazy(() => import('@material-ui/icons/Search')),
    license: USER_PLANS.udtThemeX,
  },
  {
    path: '/guideline',
    label: 'Help',
    icon: lazy(() => import('@material-ui/icons/HelpOutline')),
    license: USER_PLANS.noLicenseNeeded,
  },
];
